import { FunnelStepPageId } from 'modules/funnels/funnel/types/funnel-step-interface'

const NO_SPLIT_TEST_QUERY = '?no_split_test=1'

export const getFunnelStepPageUrl = (domainName: string, pagePath: string) => {
  return `${process.env.NEXT_PUBLIC_SIO_HOST_SCHEME}://${domainName}/${pagePath}`
}

export const getSplitTestFunnelStepPreviewUrl = (
  domainName: string,
  pagePath: string,
  inRunningSplitTest: boolean,
) => {
  return `${process.env.NEXT_PUBLIC_SIO_HOST_SCHEME}://${domainName}/${pagePath}${
    inRunningSplitTest ? NO_SPLIT_TEST_QUERY : ''
  }`
}

export const getFunnelStepPreviewUrl = (domainName: string, pagePath: string) => {
  return `${process.env.NEXT_PUBLIC_SIO_HOST_SCHEME}://${domainName}/${pagePath}?preview=actual`
}

export const getRemotePagePreviewUrl = (pageId: FunnelStepPageId) => {
  return `${window.location.origin}/dashboard/page/${pageId}/show?remote-preview=current`
}
